import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';

import TablePaginationActions from 'components/common/TablePaginationActions'
import NoDataRow from 'components/common/NoDataRow'
import LoadingRow from 'components/common/LoadingRow'

import { formatDate, PAGE_SIZE } from 'libraries/utils'

const HeaderRow = () => {
    const { t } = useTranslation();
    return (
        <TableHead>
            <TableRow>
                <TableCell style={{ paddingLeft: '30px' }}>{t('event_deadline')}</TableCell>
                <TableCell>{t('coupon_name')}</TableCell>
                <TableCell>{t('desc')}</TableCell>
                <TableCell>{t('achieving_rate')}</TableCell>
            </TableRow>
        </TableHead>
    )
} 

const ProcessingTable = (props) => {
    const [page, setPage] = useState(0)
    const { couponProcessList, data, isLoading } = props

    const handleChangePage = (newPage) => {
        if(newPage !== page){
            setPage(newPage)
            props.onPageChange(newPage)
        }
    }

    if(isLoading){
        return (
            <LoadingRow
                HeaderRow={HeaderRow}
                colSpan={4}
            />
        )
    }

    return (
        <Table>
            <HeaderRow />
            <TableBody>
                {data.getIn(['pagination', 'totalCount']) === 0 &&
                    <NoDataRow colSpan={4} />
                }
                {data.get('list').map((item, idx) => {
                    const eventEndedAt = formatDate(item.get('eventEndedAt'))
                    const processData = couponProcessList.get(item.get('storageCouponId'))
                    return (
                        <TableRow hover key={idx}>
                            <TableCell style={{ paddingLeft: '30px' }}>{eventEndedAt}</TableCell>
                            <TableCell>{item.get('name')}</TableCell>
                            <TableCell>{item.get('description')}</TableCell>
                            <TableCell>
                                {processData &&
                                    `${processData.get('currentProcess')} / ${processData.get('processTotal')}`
                                }
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
            {data.getIn(['pagination', 'totalCount']) !== 0 &&
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            className="pagination"
                            rowsPerPageOptions={[]}
                            labelDisplayedRows={() => null}
                            count={data.getIn(['pagination', 'totalCount'])}
                            rowsPerPage={PAGE_SIZE}
                            page={page}
                            onChangePage={handleChangePage}
                            ActionsComponent={TablePaginationActions}
                        />
                    </TableRow>
                </TableFooter>
            }
        </Table>
    )
}

export default ProcessingTable